import React from "react";
import Services from "../components/Services";
import Carousel from "../components/Carousel";
import "./Home.css"; // New CSS file
import "../App.css"; // New CSS file

const Home = () => {
  return (
    <div className="home-page">
      <Carousel />
      <Services />
    </div>
  );
};

export default Home;
